import { render } from "./Clients.vue?vue&type=template&id=3f66a64c&scoped=true&ts=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"

import "./Clients.vue?vue&type=style&index=0&id=3f66a64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f66a64c"]])

export default __exports__